/** @format */

import template from './gb-total-raised-widget.html';
import './gb-total-raised-widget.scss';

const TOTAL_RAISED_AMOUNT_PLACE_HOLDER = '{{total_raised}}';

export const GbTotalRaisedWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbWidget: '^^',
    },
    controller: class GbTotalRaisedWidgetComponent {
        constructor($filter) {
            'ngInject';

            this.$filter = $filter;

            this.mainStyles = {};
            this.counterStyles = {};
        }

        getCounterStyles() {
            let color = this.gbWidget.widget.color || this.gbApp.getAuction().accent_color;
            this.counterStyles['color'] = color;

            return this.counterStyles;
        }

        getTotalRaised() {
            const totalRaised = this.$filter('gbAuctionCurrency')(this.gbWidget.widget.total_raised);
            if (this.gbWidget.widget.label.includes(TOTAL_RAISED_AMOUNT_PLACE_HOLDER)) {
                return this.gbWidget.widget.label.replace(TOTAL_RAISED_AMOUNT_PLACE_HOLDER, totalRaised);
            }
            return `${this.gbWidget.widget.label} ${this.$filter('gbAuctionCurrency')(
                this.gbWidget.widget.total_raised
            )}`;
        }
    },
};
